import { environmentVariables } from '../utils/environmentVariables'
import { UserFacingError } from '../utils/errors'

const SITE_KEY = environmentVariables('RECAPTCHA_DIRECTORY_FRONTEND_SITE_KEY')

export const loadRecaptcha = (): void => {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`
  document.head.appendChild(script)
}

export const getRecaptchaToken = async (action: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    // @ts-expect-error I do not know the type of window.
    const recaptcha = window?.grecaptcha?.enterprise
    if (!recaptcha) {
      return reject(new UserFacingError('global.error_title', 'recaptcha.error_message'))
    }
    recaptcha.ready(() => {
      recaptcha
        .execute(SITE_KEY, { action })
        .then(resolve)
        .catch(() => reject(new UserFacingError('global.error_title', 'recaptcha.error_message')))
    })
  })
}
